
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../../lista/controlador';
    import _ from 'lodash';
    import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@lib/MercadoLibre/Publicaciones';
    import { Pago } from '@/__env/lib/Ventas/Pagos';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public get Seleccionados() { return this.Controlador.Seleccionados; }
        @Watch( 'Seleccionados' )
        onSeleccionados()
        {
            if ( this.Seleccionados.hasRows() )
            {
                this.SubModo = '';
                this.Abierto = true;
                this.Pedidos.clear();
                this.Busqueda = '';
                this.$nextTick( () =>
                {
                    this.Busqueda = this.Seleccionados[0].Cliente.Documento;
                } );

            }
            else
                this.Abierto = false;
        }
        public Abierto: boolean = false;

        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Publicaciones: Pago[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Publicaciones.Tipos.toTipo( a ), Publicaciones: items[a] } );
            }
            return e;
        }

        public get SeleccionadosPorCuenta()
        {
            let e: { Cuenta: string; Publicaciones: Pago[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Cuenta );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Cuenta: a, Publicaciones: items[a] } );
            }
            return e;
        }

        public SubModo: string = '';
        public Cargando: boolean = false;

        public Pedidos: Pedido[] = [];
        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Buscar();
            }

        }

        public async Buscar( forzar?: boolean )
        {
            this.Cargando = true;
            this.Pedidos.clear();
            let e = await Pedido.find( { q: this.Busqueda } );
            if ( e.Items.hasRows() )
                this.Pedidos = e.Items;
            this.Cargando = false;
        }


        Cerrar()
        {
            this.Seleccionados.clear();
        }

        async Agregar( item: Pedido )
        {

            if ( await Utiles.Mensajes.SiNo( 'Agregar pago.', `¿Agregar pago al pedido Nº ${item.Id}?` ) )
            {

                let e = await item.AgregarPagos( this.Seleccionados.map( x => x.Id.toString() ) );
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Agregado correctamente!' );
                    this.Seleccionados.clear();
                    this.Buscador.Buscar( 1 );
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al agregar pago' );
                }
            }
        }
    }
